import { http } from '../boot/axios'
import API from 'src/api'
import Group from 'src/models/Group.model'
import utils from 'src/utils'
import { Capacitor } from '@capacitor/core'

export default {
  URL: API.URL + 'forms',
  GRAPH_URL: API.GRAPHQL_URL,
  GRAPHQL_URL: API.GRAPHQL_URL + 'forms',
  fetchCritical () {
    return http.get(`${this.GRAPHQL_URL}/critical`)
  },
  fetchAll () {
    return new Promise((resolve, reject) => {
      http.get(this.GRAPHQL_URL)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchSupervised () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/supervised`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchPaginated (options = {}) {
    const { page, search, limit } = {
      ...{
        page: 1,
        search: null,
        limit: 30,
        franchise_id: null,
        organization_id: null
      },
      ...options
    }
    const isOnAdmin = options.isOnAdmin ? options.isOnAdmin : false
    const params = { isOnAdmin }
    if ('withCategory' in options) {
      params.category = options.category
      params.withCategory = options.withCategory
    }
    if ('activeFilter' in options) {
      params.activeFilter = options.activeFilter === null ? 'all' : options.activeFilter
    }

    // Filtro específico para el tipo de usuario (tester, approver, etc.)
    if (options.type) {
      params.type = options.type
    }

    params.includeTestFields = true

    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}?limit=${limit}&page=${page}` + (search ? `&search=${search}` : ''), { params })
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },

  // Nuevo endpoint específico para aprobadores
  fetchForApproval (options = {}) {
    const { page, limit } = {
      ...{
        page: 1,
        limit: 20
      },
      ...options
    }
    const params = {
      includeTestFields: true,
      limit,
      page
    }

    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPH_URL}forms/for-approval`, { params })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => { reject(error) })
    })
  },

  fetchBlocks () {
    return http.get(`${API.GRAPHQL_URL}blocks`)
  },
  createBlock (payload) {
    return http.post(`${API.GRAPHQL_URL}blocks`, payload)
  },
  removeBlock (block_id) {
    return http.delete(`${API.GRAPHQL_URL}blocks/${block_id}`)
  },
  addFormToBlock (block_id, form_id) {
    return http.post(`${API.GRAPHQL_URL}blocks/${block_id}/add-form`, { form: form_id })
  },
  removeFormFromBlock (block_id, form_id) {
    return http.post(`${API.GRAPHQL_URL}blocks/${block_id}/remove-form`, { form: form_id })
  },
  create (form) {
    form.assignment.roles = [form.assignment.roles]
    let _d = null
    if (form.assignment.start_date > form.assignment.end_date) {
      _d = form.assignment.start_date
      form.assignment.start_date = form.assignment.end_date
      form.assignment.end_date = _d
    }

    return new Promise((resolve, reject) => {
      http.post(this.GRAPHQL_URL, form)
        .then(response => { resolve(response.data) })
        .catch(err => { reject(err) })
    })
  },
  find (form_id) {
    return new Promise((resolve, reject) => {
      http.get(this.GRAPHQL_URL + '/' + form_id)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  update (form) {
    if (form.assignment) {
      form.assignment.roles = [form.assignment.roles]
      let _d = null
      if (form.assignment.start_date > form.assignment.end_date) {
        _d = form.assignment.start_date
        form.assignment.start_date = form.assignment.end_date
        form.assignment.end_date = _d
      }
    }

    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}/${form.id}`, form)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  delete (form_id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}/${form_id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  checkDependencies (formId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/${formId}/dependencies`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  getGroups (form_id) {
    return new Promise((resolve, reject) => {
      http.get(this.GRAPHQL_URL + '/' + form_id + '/groups')
        .then(data => {
          let groups = data.data.data
          let groupsArray = []
          groups.forEach((group) => {
            groupsArray.push(new Group(group))
          })
          resolve(groupsArray)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  addUpdateGroups (form) {
    let form_id = form.id
    let groups = JSON.parse(JSON.stringify(form.groups))
    let groups_ = []

    groups.forEach((group) => {
      let items_ = []
      group._items.forEach((item) => {
        if (!item.id) {
          delete item.id
        }

        // ✅ El backend espera string, lo mandamos como tal
        item.options = JSON.stringify(item.options)

        items_.push(item)
      })
      group._items = items_
      groups_.push(group)
    })

    return new Promise((resolve, reject) => {
      http
        .post(this.GRAPHQL_URL + '/' + form_id + '/updateFields', { groups: groups_ })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  updateItemOptions (item, form) {
    return new Promise((resolve, reject) => {
      http.put(`${this.URL}/${form}/items/${item.id}/options`, item)
        .then(response => { resolve(response) })
        .catch(err => reject(err))
    })
  },
  updateBlockPonderation (block) {
    return new Promise((resolve, reject) => {
      http.put(`${API.GRAPHQL_URL}blocks/${block.id}`, { ponderation: block.ponderation })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  downloadTemplate (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/downloadTemplate/${payload.id}`, payload, {
        responseType: 'blob'
      })
        .then(async response => {
          if (payload.format === 'xlsx') {
            if (Capacitor.isNativePlatform()) {
              utils.download(`${payload.name}.xlsx`, response.data, 'application/vnd.ms-excel')
            } else {
              const { saveAs } = await import('file-saver')
              saveAs(new Blob([response.data], { type: 'application/vnd.ms-excel' }), `${payload.name}.xlsx`)
            }
          }
          resolve()
        })
        .catch(error => { reject(error) })
    })
  },
  uploadTemplate (payload) {
    const upload = new FormData()
    upload.append('form_id', payload.form_id)
    upload.append('file', payload.file)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}occurrence/import/${payload.form_id}`, upload, {
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchGroupsByForm (form_id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/groups/${form_id}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchItemsByForm (group_id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/items/${group_id}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  addLogicRules (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}items/rulesLogic/${payload.index}`, payload)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  // Testing endpoints
  createTestOccurrence (formId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/create-test-occurrence`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateTestStatus (formId, status) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPH_URL}forms/${formId}/test-status`, { status })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  sendToTest (formId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/send-to-test`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  // Obtener estado de testing de formularios
  getTestingStatus (formIds = [], params = {}) {
    return new Promise((resolve, reject) => {
      const queryParams = new URLSearchParams()

      // Agregar form_ids como array
      if (formIds.length > 0) {
        formIds.forEach(id => queryParams.append('form_ids[]', id))
      }

      // Agregar otros parámetros
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key])
        }
      })

      const url = `${this.GRAPH_URL}forms/tests/testing-status${queryParams.toString() ? '?' + queryParams.toString() : ''}`

      http.get(url)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchPendingTests () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPH_URL}forms/tests/pending-tests`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  completeTest (formId, payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/complete-test`, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getTestHistory (formId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPH_URL}forms/${formId}/test-history`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  // Test answers management
  saveTestAnswer (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/save-test-answer`, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  saveTestAnswersBatch (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/save-test-answers-batch`, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getTestAnswers (occurrenceId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/test-occurrence-answers/${occurrenceId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Verificar si existe una prueba sin finalizar para un formulario
  checkExistingTest (formId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/check-existing-test/${formId}`)
        .then(response => {
          // Si el response tiene success: true, retornar la data
          if (response.data.success) {
            resolve(response.data.data)
          } else {
            // Si success es false, significa que no hay prueba activa
            resolve(null)
          }
        })
        .catch(err => {
          // Si es un 404 o similar, significa que no hay prueba activa
          if (err.response && err.response.status === 404) {
            resolve(null)
          } else {
            reject(err)
          }
        })
    })
  },
  // Aprobar formulario
  approveForm (formId, testRecordId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/approve`, {
        test_record_id: testRecordId
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Rechazar formulario
  rejectForm (formId, testRecordId, reason) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/reject`, {
        test_record_id: testRecordId,
        reason: reason
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Publicar formulario aprobado
  publishForm (formId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/publish`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Devolver formulario rechazado a borrador
  returnToDraft (formId) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/return-to-draft`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  addTestComment (formId, testRecordId, comment) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPH_URL}forms/${formId}/test-status`, {
        test_record_id: testRecordId,
        status: 'commented',
        comment: comment
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Descargar PDF de test occurrence
  downloadTestPDF (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPH_URL}forms/test-occurrences/${payload.test_occurrence_id}/download-pdf`, {
        responseType: 'blob',
        params: {
          location_name: payload.location_name,
          form_name: payload.form_name,
          isTestMode: payload.isTestMode ?? true
        }
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Enviar test occurrence por correo
  sendTestOccurrenceByEmail (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/test-occurrences/${payload.test_occurrence_id}/send-email`, {
        emails: payload.emailList,
        location_name: payload.location_name,
        form_name: payload.form_name,
        isTestMode: payload.isTestMode ?? true
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Servicios para manejar addons de test occurrence
  createTestAddon (testOccurrenceId, payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/test-occurrences/${testOccurrenceId}/addons`, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateTestAddon (testOccurrenceId, addonId, payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPH_URL}forms/test-occurrences/${testOccurrenceId}/addons/${addonId}`, payload)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteTestAddon (testOccurrenceId, addonId) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPH_URL}forms/test-occurrences/${testOccurrenceId}/addons/${addonId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Agregar comentario a formulario durante proceso de aprobación
  addApprovalComment (formId, testRecordId, comment) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPH_URL}forms/${formId}/add-comment`, {
        test_record_id: testRecordId,
        comment: comment
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  fetchCategories (organizationId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/categories`, { params: { organization_id: organizationId } })
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}
